export interface ObfuscateTextOptions {
  /**
   * Num of characters to keep revealed.
   * Default will obfuscate entire string
   * with length of maskCharCount.
   */
  lengthToKeep?: number;
  /**
   * Character to obfuscate text with
   */
  maskChar?: string;
  /**
   * The number of masked characters to display
   */
  maskCharCount?: number;
  /**
   * Position to start obfuscating text
   */
  position?: 'start' | 'end';
}

export default function obfuscateText(
  text,
  { maskChar = '•', maskCharCount = 10, lengthToKeep = 0, position = 'start' }: ObfuscateTextOptions = {},
): string {
  if (!lengthToKeep) {
    return maskChar?.repeat(maskCharCount);
  }

  let charsToKeep;

  if (position === 'end') {
    charsToKeep = text.substring(0, lengthToKeep);

    return charsToKeep + maskChar?.repeat(maskCharCount);
  } else {
    charsToKeep = text.substring(text.length - lengthToKeep);

    return maskChar?.repeat(maskCharCount) + charsToKeep;
  }
}
